<template>
  <div class="link-bot-agent-select" :data-testid="dataTestId">
    <p class="link-bot-drawer__section-label">
      Select {{ botName }}
    </p>
    <div class="link-bot-agent-select__list" role="radiogroup" :aria-label="`Select ${botName}`">
      <button
        v-for="option in agentOptions"
        :key="option.value"
        type="button"
        class="link-bot-agent-select__card"
        :class="{ 'link-bot-agent-select__card--selected': isSelected(option) }"
        role="radio"
        :aria-checked="isSelected(option)"
        :data-testid="`${dataTestId}__option--${toTestId(option.value)}`"
        @click="$emit('input', option.value)"
      >
        <span class="link-bot-agent-select__glyph" aria-hidden="true">{{ option.initial }}</span>
        <span class="link-bot-agent-select__info">
          <span class="link-bot-agent-select__name">{{ option.name }}</span>
          <span v-if="option.description" class="link-bot-agent-select__description">
            {{ option.description }}
          </span>
        </span>
        <span
          class="link-bot-agent-select__radio"
          :class="{ 'link-bot-agent-select__radio--selected': isSelected(option) }"
          aria-hidden="true"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { getLinkBotAgentOptions } from '@/modules/financialclose/utils/linkBotConstants';

export default {
  name: 'LinkBotAgentSelect',

  props: {
    value: {
      type: String,
      default: '',
    },
    botList: {
      type: Array,
      default: () => [],
    },
    botName: {
      type: String,
      default: '',
    },
    dataTestId: {
      type: String,
      default: 'link-bot-agent-select',
    },
  },

  computed: {
    agentOptions() {
      return getLinkBotAgentOptions(this.botList);
    },
  },

  methods: {
    isSelected(option) {
      return this.value === option.value || this.value === option.name;
    },

    toTestId(name) {
      return String(name || '').toLowerCase().replace(/\s+/g, '-');
    },
  },
};
</script>
